export const
    GET_INITIAL_DATA_FAILURE= "GET_INITIAL_DATA_FAILURE",
    GET_INITIAL_DATA_REQUEST= "GET_INITIAL_DATA_REQUEST",
    GET_INITIAL_DATA_SUCCESS= "GET_INITIAL_DATA_SUCCESS";


// WEBPACK FOOTER //
// ./src/types/InitialData.js